export default "__VITE_ASSET__343148fc__"